class MgmProductUpsells extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('change', this.onChange.bind(this));
  }

  onClick(event) {
    const individualButton = event.target?.closest?.('[data-mgm-upsell-add]');
    if (individualButton instanceof HTMLButtonElement) {
      this.addItems(this.getItemsFromCard(individualButton.closest('[data-mgm-upsell-card]')), individualButton);
      return;
    }

    const selectedButton = event.target?.closest?.('[data-mgm-upsell-add-selected]');
    if (selectedButton instanceof HTMLButtonElement) {
      this.addItems(this.getSelectedItems(), selectedButton);
    }
  }

  onChange(event) {
    const target = event.target;

    if (target instanceof HTMLSelectElement && target.matches('[data-mgm-upsell-variant-select]')) {
      this.updateSelectedVariant(target);
    }

    if (target instanceof HTMLInputElement && target.matches('[data-mgm-upsell-checkbox]')) {
      this.updateSelectedButtonState();
    }
  }

  getSelectedItems() {
    return Array.from(this.querySelectorAll('[data-mgm-upsell-checkbox]:checked'))
      .map((input) => this.getItemsFromCard(input.closest('[data-mgm-upsell-card]')))
      .flat();
  }

  getItemsFromCard(card) {
    if (!(card instanceof HTMLElement)) return [];

    const variantId = card.dataset.mgmSelectedVariantId;
    const quantityInput = card.querySelector('[data-mgm-upsell-quantity]');
    const quantity = quantityInput instanceof HTMLInputElement ? Number(quantityInput.value) || 1 : 1;
    const productTitle = card.dataset.mgmProductTitle || 'Upsell';

    if (!variantId) return [];

    return [
      {
        variantId,
        quantity: Math.max(1, quantity),
        properties: {
          _mgm_upsell: productTitle,
        },
      },
    ];
  }

  addItems(items, button) {
    if (!items.length) return;

    const productForm = this.closest('.shopify-section')?.querySelector('product-form-component');
    if (!(productForm instanceof HTMLElement)) return;

    this.setButtonLoading(button, true);

    productForm.dispatchEvent(
      new CustomEvent('mgm:batch-add-to-cart', {
        bubbles: true,
        cancelable: true,
        detail: { items },
      })
    );

    window.setTimeout(() => {
      this.setButtonLoading(button, false);
      this.setButtonAdded(button);
    }, 650);
  }

  updateSelectedVariant(select) {
    const card = select.closest('[data-mgm-upsell-card]');
    if (!(card instanceof HTMLElement)) return;

    const option = select.options[select.selectedIndex];
    const available = option.dataset.mgmVariantAvailable !== 'false';

    card.dataset.mgmSelectedVariantId = select.value;

    const price = card.querySelector('[data-mgm-upsell-price]');
    if (price && option.dataset.mgmVariantPrice) {
      price.textContent = option.dataset.mgmVariantPrice;
    }

    const button = card.querySelector('[data-mgm-upsell-add]');
    if (button instanceof HTMLButtonElement) {
      button.disabled = !available;
      button.textContent = available ? this.dataset.addText || 'Add' : this.dataset.soldOutText || 'Sold out';
    }

    const checkbox = card.querySelector('[data-mgm-upsell-checkbox]');
    if (checkbox instanceof HTMLInputElement) {
      checkbox.disabled = !available;
      if (!available) checkbox.checked = false;
      this.updateSelectedButtonState();
    }
  }

  updateSelectedButtonState() {
    const button = this.querySelector('[data-mgm-upsell-add-selected]');
    if (!(button instanceof HTMLButtonElement)) return;

    const selectedCount = this.querySelectorAll('[data-mgm-upsell-checkbox]:checked').length;
    button.disabled = selectedCount === 0;
    button.textContent =
      selectedCount > 0
        ? (this.dataset.selectedText || 'Add selected').replace('[count]', String(selectedCount))
        : this.dataset.emptyText || 'Choose an item';
  }

  setButtonLoading(button, isLoading) {
    if (!(button instanceof HTMLButtonElement)) return;

    if (isLoading) {
      button.dataset.mgmPreviousText = button.textContent || '';
      button.disabled = true;
      button.textContent = this.dataset.loadingText || 'Adding...';
      return;
    }

    button.disabled = false;
    if (button.dataset.mgmPreviousText) button.textContent = button.dataset.mgmPreviousText;
  }

  setButtonAdded(button) {
    if (!(button instanceof HTMLButtonElement)) return;

    const previousText = button.textContent || '';
    button.textContent = this.dataset.addedText || 'Added';

    window.setTimeout(() => {
      button.textContent = previousText;
      this.updateSelectedButtonState();
    }, 1200);
  }
}

if (!customElements.get('mgm-product-upsells')) {
  customElements.define('mgm-product-upsells', MgmProductUpsells);
}
